import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-apple-pay',
  templateUrl: './apple-pay.component.html',
  styleUrls: ['./apple-pay.component.scss']
})
export class ApplePayComponent implements OnInit {

  link: string;
  private lock: boolean = false;
  constructor(
    private router:Router,
    private sessionService:SessionService,
    private route: ActivatedRoute
  ) {
    this.link = "card/apple-pay";
  }

  ngOnInit(): void {
    this.selectMethod();
    this.sessionService.getPaymentMethodListLock().subscribe((lock:boolean) => {
      this.lock = lock;
    });
  }

  selectMethod(event?: Event){
    sessionStorage.setItem("selected-payment","apple-pay");
    if(event!=undefined &&!this.lock){
      this.sessionService.emitSelectedPaymentMethod("apple-pay");
      this.router.navigate(['card/add'], { skipLocationChange: true, relativeTo: this.route } ).then(() => {
        this.router.navigate([this.link], {relativeTo: this.route});
      });
      // this.router.navigate([this.link],{relativeTo: this.route});
    }
  }

}
